export default function loadLdDebugger(context) {
    const queryParams = new URLSearchParams(document.location.search);
    if (queryParams.has("debugld")) {
        const value = queryParams.get("debugld");
        if (value) {
            import("./index.js").then((module) => module.default(context, value.split(",")));
        }
    }
}
